// extracted by mini-css-extract-plugin
export var search_results = "SearchResult-module--search_results--0FyM5";